import styled from 'styled-components';
import { playFontSize } from '../../../../ui-components/typography/helpers';
import { fontWeightRegular, fontWeightBold, regularWhite } from '../../../../ui-components/design-tokens';
import { device } from '../../../../ui-components/breakpoints';

export const StyledErrorPage = styled.div`
    margin-top: 50px;
    color: ${regularWhite};
`;

export const ListHeading = styled.p`
    ${playFontSize(1.7)};
    line-height: 1.4;
    margin-top: 1.8em;
    font-weight: ${fontWeightRegular};

    @media ${device.GteMedium} {
        font-weight: ${fontWeightBold};
    }

    @media ${device.GteLarge} {
        font-weight: ${fontWeightBold};
    }
`;

export const List = styled.ul`
    padding: 0 0 0 1.15em;
    line-height: 1.4;
    margin-bottom: 1.4em;
    margin-top: 0.2em;
    font-size: 1.6rem;

    @media ${device.GteSmall} {
        font-size: 1.7rem;
    }
`;
